"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFtlOrderV1ApiErrorCode = void 0;
exports.CreateFtlOrderV1ApiErrorCode = {
    INVALID_TRADING_PARTNER_BOOKING_FIELD_DATA: 'INVALID_TRADING_PARTNER_BOOKING_FIELD_DATA',
    REQUIRED_TRADING_PARTNER_BOOKING_FIELDS_MISSING: 'REQUIRED_TRADING_PARTNER_BOOKING_FIELDS_MISSING'
};
//# sourceMappingURL=create-ftl-order-v1-api-error-code.js.map